/**
 * Tiny classNames joiner for the ui primitives.
 * Filters out falsy values so conditional classes read cleanly:
 *   cn(styles.btn, styles[variant], isActive && styles.active, className)
 * No dependency (no clsx / tailwind-merge — we don't use Tailwind).
 */
export function cn(...parts) {
  return parts.filter(Boolean).join(" ");
}

export default cn;
